/**
 * Planning 模块枚举定义
 * 
 * @module types/planning/enums
 * @description 计划管理模块（MRP运算、齐套分析）的枚举类型定义
 * 
 * @source 对应后端文件:
 * - backend/app/Modules/Planning/Services/MrpCalculationService.php
 * - backend/app/Modules/Planning/Services/KitCheckService.php
 * 
 * @generated AI-assisted
 * @created 2025-12-09
 */

/**
 * MRP 物料状态枚举
 * 
 * 用于标识物料的缺料严重程度
 */
export enum MrpMaterialStatus {
  /** 严重缺料（缺料比例≥80%） */
  CRITICAL = 'CRITICAL',
  /** 缺料警告（缺料比例50%-80%） */
  WARNING = 'WARNING',
  /** 轻微缺料（缺料比例<50%） */
  INFO = 'INFO',
  /** 库存充足 */
  OK = 'OK',
}

/**
 * 齐套状态枚举
 * 
 * 用于标识工单/BOM的整体齐套状态
 */
export enum KitCheckStatus {
  /** 完全齐套，可开工 */
  READY = 'READY',
  /** 基本齐套（齐套率≥80%） */
  PARTIAL = 'PARTIAL',
  /** 缺料警告（齐套率50%-80%） */
  WARNING = 'WARNING',
  /** 严重缺料（齐套率<50%） */
  CRITICAL = 'CRITICAL',
  /** 工单已完成 */
  COMPLETED = 'COMPLETED',
}

/**
 * 采购建议优先级枚举
 * 
 * 与后端 PurchaseOrder 的优先级常量对应
 */
export enum PurchaseSuggestionPriority {
  /** 紧急 */
  URGENT = 1,
  /** 高 */
  HIGH = 2,
  /** 中 */
  MEDIUM = 3,
  /** 低 */
  LOW = 4,
}
